
import api from '@/api/co.api'
import app from '@/api/co.app'
import { EventBus } from '@/api/co.event';

import comm from '@/api/socket/co.socket.comm'
import cacher from '@/api/socket/co.socket.cacher'
import receiver from '@/api/socket/co.socket.receiver'
import tasker from '@/api/socket/co.socket.tasker'

// import JSONBig from 'json-bigint'
import dayjs from 'dayjs'

let heartbeatInterval = 30000; // 30秒发送一次心跳
let heartbeatTimeout = 5000;   // 5秒没收到响应则认为断开
let heartbeatTimer = null;
let timeoutTimer = null;
let reconnectTimer = null;
let reconnectCount = 0;
let maxReconnectCount = 10;
let reconnectDelay = 1000;
let isManualClose = false;
let personId = null;

const socketMain = {
  comm,
  cacher,
  receiver,
  tasker,

  initialize () {
    console.log('co.socket initialize!')
    receiver.handlers[comm.Types.ENSURE] = {
      action: receiver.toEnsure
    }

    receiver.handlers[comm.Types.SINGLE] = {
      action: receiver.toPrivate
    }

    // receiver.handlers[comm.Types.GROUP] = {
    //   action: receiver.toGroup
    // }

    this.bind({ name: 'cach_received', trigger: cacher.received })
  },

  emit (event, param = {}) {
    // console.log('co.socket emit, event: %s', event)
    // console.log('co.socket emit, param: %o', param)
    app.emit(event, param)
  },

  convertToJson (jsonStr) {
    let result = {}
    try {
      result = JSON.parse(jsonStr)
    } catch (e) {
      result = {}
    }
    return result
  },

  convert (data) {
    const result = api.comm.jsonToObject(data)

    let content = null
    if (result.type === 'chat') {
      content = result.content
    } else {
      content = api.comm.jsonToObject(result.content)
    }

    let createTime = ''
    let updateTime = ''
    let hintTime = ''

    if (result.createTime) {
      const ct = parseInt(result.createTime, 10)
      createTime = dayjs(ct).format('YYYY-MM-DD HH:mm')
      hintTime = dayjs(ct).format('M-D HH:mm')
    }

    if (result.updateTime) {
      const ut = parseInt(result.updateTime, 10)
      updateTime = dayjs(ut).format('YYYY-MM-DD HH:mm')
      if (!hintTime) {
        hintTime = dayjs(ut).format('M-D HH:mm')
      }
    }

    const to = {
      userId: result.toId,
      username: result.toUsername,
      avatar: result.toAvatar
    }

    let from = {}

    if (result.type === 'chat') {
      from = {
        userId: result.fromId || '',
        username: result.fromUsername || '',
        avatar: result.fromAvatar || ''
      }
    } else {
      from = {
        userId: content.userId || '',
        username: content.username || '',
        avatar: content.avatar || ''
      }
    }

    return {
      msgId: result.msgId,
      type: result.type,
      content,
      contentType: result.contentType,
      to,
      from,
      fromId: from.userId,
      toId: to.userId,
      state: result.state,
      createTime,
      updateTime,
      hintTime
    }
  },

  connect ({ userId }) {
    let me = this;
    personId = userId
    const url = `${api.url.web_im_socket}/${userId}/web`
    console.log('co.socket.main connect: 尝试连接WebSocket', { url, userId });

    if ('WebSocket' in window) {
      try {
        tasker.handler = new WebSocket(url)

        tasker.handler.onopen = function () {
          console.log('co.socket.main onopen:', { userId, url });
          tasker.opened = true
          tasker.userId = userId
          tasker.handler.send("Hello, server!");
          socketMain.emit(comm.Events.SOCKET_OPEN, { userId })
        }

        tasker.handler.onmessage = function (res) {
          console.log('co.socket.main socket 连接成功！');
          // console.log('co.socket.main onmessage:', {
          //   data: res.data,
          //   userId: tasker.userId
          // });

          if (res.data) {
            try {
              const msg = socketMain.convert(res.data)
              console.log('co.socket.main onmessage:', {original: res.data,converted: msg});
              EventBus.$emit('message', msg);
              EventBus.$emit('messageChat', msg);
              cacher.add(msg)
              socketMain.trigger(msg)
            } catch (err) {
              console.warn('co.socket onmessage err:', {
                data: res.data,
                error: err
              });
            }
          }
        }

        tasker.handler.onerror = function (res) {
          console.warn('co.socket.main onerror: WebSocket连接错误', {
            error: res,
            userId: tasker.userId,
            url
          });

          socketMain.emit(
            comm.Events.SOCKET_ERROR,
            {
              ...res,
              userId: tasker.userId
            }
          )
        }

        tasker.handler.onclose = function (res) {
          console.log('co.socket.main onclose: WebSocket连接关闭', {
            code: res.code,
            reason: res.reason,
            wasClean: res.wasClean,
            userId: tasker.userId
          });

          tasker.opened = false
          tasker.handler = undefined
          socketMain.emit(
            comm.Events.SOCKET_CLOSE,
            {
              userId: tasker.userId,
              code: res.code,
              isTrusted: res.isTrusted,
              reason: res.reason || '',
              type: res.type,
              wasClean: res.wasClean
            }
          )

          me.clearHeartbeat();

          if (!isManualClose) {
            me.reconnect();
          }
        }
      } catch (err) {
        console.error('co.socket connect: 创建WebSocket失败', {
          error: err,
          url,
          userId
        });

        socketMain.emit(
          comm.Events.SOCKET_ERROR,
          {
            error: err,
            userId: userId
          }
        )
      }
    } else {
      console.warn('co.socket connect: 浏览器不支持WebSocket');
      socketMain.emit(comm.Events.SOCKET_NOTIN, { desc: '浏览器不支持即时通讯！' })
    }
  },
  reply ({
    messageId,
    status = comm.States.RECEIVED
  }) {
    receiver.reply({ messageId, status })
  },
  close () {
    if (tasker.handler) {
      tasker.handler.close()
    }
  },
  bind ({ name, trigger }) {
    if (!name) {
      return
    }

    tasker.dispatchers[name] = {
      name,
      trigger
    }
  },
  unbind (name) {
    if (!name) {
      return
    }
    const item = tasker.dispatchers[name]
    if (item) {
      tasker.dispatchers[name] = undefined
    }
  },
  trigger (msg) {
    for (const key in tasker.dispatchers) {
      const item = tasker.dispatchers[key]
      if (item) {
        if (typeof item.trigger === 'function') {
          item.trigger(msg)
        }
      }
    }
  },
  send (message) {
    // console.log('co.socket.main send data: %o', message)
    const prom = new Promise(function (resolve, reject) {
      if (tasker.opened && message) {
        tasker.handler.send(message)
        resolve({ status: true, message })
      } else {
        let result = ''
        if (!tasker.opened) {
          result = '还没建立通讯连接'
        }

        if (!message) {
          result = '发送信息为空'
        }

        reject(result)
      }
    })

    return prom
  },
  // 发送心跳
  sendHeartbeat() {
    const heartbeatMsg = JSON.stringify({ type: 'ping', timestamp: Date.now() });
    tasker.handler.send(heartbeatMsg)
  },

  // 重置心跳（收到pong时调用）
  resetHeartbeat() {
    clearTimeout(timeoutTimer);
    timeoutTimer = null;
  },

  // 开始超时检查
  startTimeoutCheck() {
    timeoutTimer = setTimeout(() => {
      console.warn('心跳超时，准备重连');
      tasker.handler.close();
    }, heartbeatTimeout);
  },
  // 清除心跳定时器
  clearHeartbeat() {
    clearInterval(heartbeatTimer);
    clearTimeout(timeoutTimer);
    clearTimeout(reconnectTimer);
    heartbeatTimer = null;
    timeoutTimer = null;
    reconnectTimer = null;
  },
  // 重连机制
  reconnect() {

    clearTimeout(reconnectTimer);

    // 指数退避策略
    const delay = reconnectDelay * Math.pow(1.5, reconnectCount);
    reconnectCount++;

    console.log(`第${reconnectCount}次重连，${delay}ms后尝试`);

    reconnectTimer = setTimeout(() => {
      this.connect({ userId: personId });
    }, delay);
  }
}

export default socketMain
